<div class="digitOffer" *transloco="let t">
	<mat-card id="digitOffer" class="card">
		<mat-card-title class="title">
			<div class="op-display-3-font" [ngClass]="{ spanish: isSpanish }">
				<div class="op-display-3-font title1">{{ t('DIGIT_OFFER_FOR_NOT_APPROVED.title1') }}</div>
				<div class="op-ul-white-dis2 op-display-2-font title2">{{ t('DIGIT_OFFER_FOR_NOT_APPROVED.title2') }}</div>
			</div>
			<div class="op-body-1-font op-mt-8 op-primary-black">
				{{ t('DIGIT_OFFER_FOR_NOT_APPROVED.automatedSavings') }}
			</div>
		</mat-card-title>
		<mat-card-content class="content">
			<div>
				<button mat-flat-button id="digitOfferDeclineButton" color="primary-small" (click)="goToDigit()">
					{{ t('DIGIT_OFFER_FOR_NOT_APPROVED.getNow') }}
				</button>
				<div class="op-micro-font op-light-black op-mt-8">
					{{ t('DIGIT_OFFER_FOR_NOT_APPROVED.costPerMonth') }}
				</div>
				<div class="bottom">
					<div></div>
					<div class="op-micro-font op-light-black op-mt-8">
						{{ t('DIGIT_OFFER_FOR_NOT_APPROVED.availableOn') }}
						<div>
							<img
								class="platform-image op-mt-5"
								[src]="'/assets/images/digit/iPhoneAndroid.svg'"
								alt="app offer"
								role="presentation"
							/>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div class="automatic-saving-image">
					<img class="phone-image" [src]="image" alt="app offer" role="presentation" />
				</div>
			</div>
		</mat-card-content>
	</mat-card>
	<div class="disclaimer op-micro-font op-mt-8">
		<div id="esDisclaimer" class="op-mt-10 op-left op-light-black">
			{{ 'DIGIT_OFFER_FOR_NOT_APPROVED.disclaimer' | transloco }}
		</div>
	</div>
</div>
